module.exports = __webpack_public_path__ + "img/ventana.e197f8af.svg";